import { render } from "./BlackConfirmModal.vue?vue&type=template&id=8b2e87ba&scoped=true"
import script from "./BlackConfirmModal.vue?vue&type=script&lang=js"
export * from "./BlackConfirmModal.vue?vue&type=script&lang=js"

import "./BlackConfirmModal.vue?vue&type=style&index=0&id=8b2e87ba&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b2e87ba"]])

export default __exports__